import { render, staticRenderFns } from "./join-bar.vue?vue&type=template&id=6db0faf5&scoped=true"
import script from "./join-bar.vue?vue&type=script&lang=js"
export * from "./join-bar.vue?vue&type=script&lang=js"
import style0 from "./join-bar.vue?vue&type=style&index=0&id=6db0faf5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db0faf5",
  null
  
)

export default component.exports